module.exports = __webpack_public_path__ + "static/media/options.234a0828.svg";